const PRODUCT_TAG_PATTERNS = [
    { pattern: /\bjira\b/i, modifier: 'usa-tag--jira' },
    { pattern: /\bconfluence\b/i, modifier: 'usa-tag--confluence' },
    { pattern: /\bgit\s*lab\b/i, modifier: 'usa-tag--gitlab' },
    { pattern: /\baws\b/i, modifier: 'usa-tag--aws' },
    { pattern: /\bnexus\b/i, modifier: 'usa-tag--nexus' },
    { pattern: /\bkeycloak\b/i, modifier: 'usa-tag--keycloak' },
    { pattern: /\bunlock\b/i, modifier: 'usa-tag--unlock' },
];

export const getProductTagModifier = (label) => {
    const normalizedLabel = String(label ?? '').trim();
    if (!normalizedLabel) {
        return '';
    }

    return PRODUCT_TAG_PATTERNS.find(({ pattern }) => pattern.test(normalizedLabel))?.modifier ?? '';
};

export const getProductTagClassName = (label, baseClassName = 'usa-tag') => {
    const modifier = getProductTagModifier(label);
    return modifier ? `${baseClassName} ${modifier}` : baseClassName;
};
